// API
export const GET_CATCHUP_RECORDING_DATA_API =
	'ingester/catchup/:programUuid/details';

// Queries
export const CATCHUP_RECORDING_DATA = 'CATCHUP_RECORDING_DATA';
